<ng-container *ngIf="data">
    <div class="modal-header">
        <h6 class="modal-title medium" *ngIf="data.heading">{{data.heading | translate }}</h6>
        <h6 class="modal-title medium" *ngIf="data.isConformation">{{'confirmation' | translate }}</h6>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="w-100 float-left p-4 modal-body" *ngIf="!isErrorMessage && data.confirmationMessage">
        <h6 class="mb-2 medium">{{data.confirmationMessage | translate}}</h6>
    </div>

    <div class="w-100 float-left p-4 modal-body" *ngIf="data.errors && data.errors.length > 0">
        <h6 class="mb-2 medium" *ngFor="let error of data.errors">{{error | translate}}</h6>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary float-right" *ngIf="data.isConformation" [disabled]="disabledButton"
                (click)="continue()">
            {{data.yesButtonText | translate}}
        </button>
        <button class="btn btn-secondary float-right" [disabled]="disabledButton" (click)="close()">
            {{data.noButtonText | translate}}
        </button>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/confirmation/confirmationModel.html